import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RedirectPageModule } from './redirect/redirect.module';

const routes: Routes = [
  {
    loadChildren: () => RedirectPageModule,
    path: 'redirect'
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'redirect'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class PaymentRoutingModule {}
